/* eslint-disable no-param-reassign */
import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
export const initialState = {
    canUseLoyalty: false,
    canSkipDefaultNonStackableOffers: false,
};
export const canUseLoyaltyChanged = createAction('offerOptions/canUseLoyaltyChanged');
export const canSkipDefaultNonStackableOffersChanged = createAction('offerOptions/canSkipDefaultNonStackableOffersChanged');
export const resetOfferOptions = createAction('offerOptions/resetOfferOptions');
export const selectCanUseLoyalty = createSelector((state) => state.offerOptions, options => options.canUseLoyalty);
const offerOptions = createReducer(initialState, builder => {
    builder
        .addCase(canUseLoyaltyChanged, (state, action) => {
        state.canUseLoyalty = action.payload;
    })
        .addCase(canSkipDefaultNonStackableOffersChanged, (state, action) => {
        state.canSkipDefaultNonStackableOffers = action.payload;
    })
        .addCase(resetOfferOptions, () => initialState);
});
export const getOfferOptions = (state) => state.offerOptions;
export default offerOptions;
